const routes: any = {
  LOGIN: '/login',
  DASH_DATA: '/api/dashboard-data',
  DASHBOARD: '/clientes/dashboard',
  CLIENTES: {
    LIST : '/clientes/list',
    POST : '/clientes',
    FIND : '/clientes/:cnpj/find',
    UPDATE: '/clientes/:cnpj/update',
    DELETE: '/clientes/:cnpj/destroy',
  },
  PRODUTOS: {
    LIST : '/produtos/list',
    FIND : '/produtos/:id/find',
    EDIT : '/produtos/:id',
    CREATE : '/produtos',
    DELETE : '/produtos/:id',
  },
  PEDIDOS: {
    LIST : '/pedidos',
    POST : '/pedidos',
    EDIT: '/pedidos/:id/find',
    UPDATE: '/pedidos/:id',
    DELETE: '/pedidos/:id',
    COUNT: '/pedidos/countUnits',
    ITENS: {
      LIST: '/pedidos/itens/list',
      POST: '/pedidos/itens',
      DELETE: '/pedidos/itens',
    }
  },
  CONFIG: {
    SHOW: '/config',
    UPDATE: '/config',
  },
  USUARIOS: {
    LIST : '/usuarios',
    POST : '/usuarios',
    FIND : '/usuarios/:id/find',
    UPDATE: '/usuarios/:id/update',
    DELETE: '/usuarios/:id',
  },
  TABELA_PRECOS: {
    LIST: '/tabela-precos',
    FIND: '/tabela-precos/:id'
  },
  PRAZOS_PAGAMENTOS:{
    LIST : '/prazo-pagamentos',
    FIND: '/prazo-pagamentos/:id',
    CREATE: '/prazo-pagamentos',
    DELETE: '/prazo-pagamentos/:id',
  }
}

// Function to get the correct base URL based on NODE_ENV
//import { getBaseURL } from './environment';
const baseURL = 'https://cappellusweb.bassena.com.br/api';//getBaseURL();


const buildRoutes = (baseURL: string, routes: any): any => {
  const buildRoute = (route: string): string => `${baseURL}${route}`;


  const traverseAndBuild = (obj: any): any => {
    const result: any = {};
    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        result[key] = traverseAndBuild(obj[key]);
      } else {
        result[key] = buildRoute(obj[key]);
      }
    }
    return result;
  };

  return traverseAndBuild(routes);
};

export const BackEndRoutes = {
  getHost: '',
  routes: buildRoutes(baseURL, routes), // Routes with full URLs
};
